export default {"src":"/_next/static/media/proactive.8daf8e33.svg","height":41,"width":171,"blurWidth":0,"blurHeight":0};